import React, { useState, useEffect } from "react";
import { Redirect } from "react-router";
import { post } from "../api";
import { resourceUrls } from "../../config";

import Loading from "../../components/Loading";
import Error from "../../components/Error";
import { handlePost } from "../api/handler";

const submitApplication = async (
    setIsLoggedIn,
    setError,
    setIsLoading,
    setSubmissionComplete
) => {
    setIsLoading(true);

    await handlePost({
        postApiCall: () => post({ url: resourceUrls.submit.submit }),
        setIsLoggedIn: setIsLoggedIn,
        setError: setError,
        setIsSubmissionComplete: setSubmissionComplete,
    });

    setIsLoading(false);
};

const Submit = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [isLoggedIn, setIsLoggedIn] = useState(true);
    const [error, setError] = useState(null);
    const [submissionComplete, setSubmissionComplete] = useState(null);

    useEffect(() => {
        submitApplication(
            setIsLoggedIn,
            setError,
            setIsLoading,
            setSubmissionComplete
        );
    }, []);

    if (submissionComplete) {
        return (
            <Redirect
                push
                to={{
                    pathname: "/secure/apply",
                }}
            />
        );
    }

    if (isLoading) return <Loading />;

    if (error) return <Error error={error} />;
};

export default Submit;
